/* eslint-disable import/no-cycle */
import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import i18n from '@/libs/i18n'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useMaintenancePlanList() {
  // Use toast
  const toast = useToast()

  const refMaintenancePlanListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'name', label: i18n.t('Maintenance Plan'), sortable: false },
    { key: 'customerName', label: i18n.t('Customer'), sortable: false },
    {
      key: 'stepsCount',
      label: i18n.t('Steps'),
      sortable: false,
      thClass: 'text-center',
      tdClass: 'text-center',
    },
    {
      key: 'assetsCount',
      label: i18n.t('Linked Assets'),
      sortable: false,
      thClass: 'text-center',
      tdClass: 'text-center',
    },
    {
      key: 'actions',
      label: i18n.t('Actions'),
      thClass: 'text-right',
      tdClass: 'text-right',
    },
  ]

  const perPage = ref(10)
  const totalMaintenancePlan = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)

  const dataMeta = computed(() => {
    const localItemsCount = refMaintenancePlanListTable.value ? refMaintenancePlanListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalMaintenancePlan.value,
    }
  })

  const refetchData = () => {
    if (refMaintenancePlanListTable.value) {
      refMaintenancePlanListTable.value.refresh()
    }
  }

  watch([currentPage, perPage, searchQuery], () => {
    refetchData()
  })

  const fetchAllMaintenancePlan = (ctx, callback) => {
    store
      .dispatch('app-management/fetchAllMaintenancePlan', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
      })
      .then(response => {
        const payload = response.data || {}
        const maintenance = payload.data || (Array.isArray(payload) ? payload : [])
        let total = 0
        if (payload.totalItems !== undefined) {
          total = payload.totalItems
        } else if (payload.length !== undefined) {
          total = payload.length
        } else {
          total = maintenance.length
        }

        callback(maintenance)
        totalMaintenancePlan.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: i18n.t('Error fetching maintenance plans list'),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  return {
    fetchAllMaintenancePlan,
    tableColumns,
    perPage,
    currentPage,
    totalMaintenancePlan,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refMaintenancePlanListTable,
    refetchData,
  }
}
